import styled from "styled-components";
import {PrimaryLink} from "components";
import bg from "assets/images/landing-badges-background.png";

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	padding: 20px 20px 40px;
	background: #931a20;
	width: 100%;
	text-align: left;
	background: url(${bg}) no-repeat center;
	background-size: cover;

	@media (min-width: 769px) {
		padding: 40px 46px;
	}
`;

export const Container = styled.div`
	width: 100%;
	max-width: 1340px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;

	@media (min-width: 769px) {
		flex-direction: row;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 40%;
	align-items: flex-start;
	width: 100%;
	margin-bottom: 20px;

	@media (min-width: 769px) {
		width: auto;
		margin-bottom: 0;

		a {
			min-width: 195px;
		}
	}
`;

export const TitleContainer = styled.div`
	background: #2e2e2e;
	color: ${({theme}) => theme.color.tertiary};
	padding: 12px;
	margin-bottom: 20px;
	width: 100%;

	@media (min-width: 769px) {
		margin-bottom: 28px;
	}
`;

export const Title = styled.h2`
	font-weight: 700;
	font-family: "Khand", sans-serif;
	line-height: 120%;
	font-size: 22px;

	@media (min-width: 769px) {
		font-size: 30px;
	}
`;

export const SubTitle = styled.div`
	font-weight: 500;
	line-height: 160%;
	font-size: 16px;

	@media (min-width: 769px) {
		font-size: 20px;
	}
`;

export const ImgContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	gap: 24px;

	@media (min-width: 769px) {
		margin-left: 0;
		padding-left: 60px;
	}
`;

export const Link = styled(PrimaryLink)`
	max-width: 188px;

	@media (min-width: 769px) {
		max-width: 195px;
	}
`;
